var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOffice365(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.042 1.51237L9.93 1.58037C9.7515 1.68837 9.583 1.80937 9.426 1.94137L9.75 1.71337H12.5L13 5.49937L10.5 7.99937L8 9.73687V11.7404C8 13.1399 8.7315 14.4374 9.9285 15.1624L12.5605 16.7554L7 19.9994H5.9275L3.9285 18.7894C2.7315 18.0649 2 16.7669 2 15.3674V8.62987C2 7.22987 2.732 5.93187 3.93 5.20737L9.93 1.57787C9.967 1.55537 10.0045 1.53337 10.042 1.51237Z",
    fill: "url(#paint0_radial_21573_192831)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.49937V11.7394C16 13.1389 15.2685 14.4364 14.0715 15.1614L8.0715 18.7934C6.844 19.5364 5.317 19.5634 4.068 18.8739L9.929 22.4214C11.2025 23.1924 12.7985 23.1924 14.0715 22.4214L20.0715 18.7894C21.2685 18.0649 22 16.7669 22 15.3674V13.7494L21.5 12.9994L16 9.49937Z",
    fill: "url(#paint1_radial_21573_192831)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.07 5.20687L14.07 1.57737C12.8365 0.831367 11.301 0.808367 10.0485 1.50787L9.93 1.58037C8.732 2.30487 8 3.60337 8 5.00287V9.74487L9.93 8.57737C11.203 7.80737 12.7975 7.80737 14.0705 8.57737L20.0705 12.2069C21.231 12.9089 21.954 14.1489 21.998 15.4984C21.9995 15.4549 22 15.4114 22 15.3674V8.62937C22 7.22987 21.268 5.93137 20.07 5.20687Z",
    fill: "url(#paint2_radial_21573_192831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21573_192831",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.215 5.51792) rotate(119.774) scale(20.113 46.0445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21573_192831",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.25869 15.1116) rotate(-12.1282) scale(17.5224 16.5147)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#BF8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#591C96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21573_192831",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5218 13.2736) rotate(-165.772) scale(14.8291 24.9633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3079D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOffice365);
export default __webpack_public_path__ + "static/media/MicrosoftOffice365.1d7b1e36fe931dd12a9724e76365fafd.svg";
export { ForwardRef as ReactComponent };